export const TextProp = Object.freeze({
    Text: 'text',
});